import { Link } from 'react-router-dom';

export default function ComingSoon() {
  return (
    <main id="main" className="py-24">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-nkc-gold">Coming soon</p>
        <h1 className="mt-3 font-display text-3xl font-bold text-nkc-navy sm:text-5xl">
          This page is on its way
        </h1>
        <p className="mx-auto mt-4 max-w-xl text-nkc-muted">
          We are migrating pages one at a time. The homepage is available now, and more sections will follow after review.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex rounded-2xl bg-nkc-blue px-6 py-3 text-sm font-bold text-white hover:bg-nkc-navy"
        >
          Back to homepage
        </Link>
      </div>
    </main>
  );
}
